export const utils = {
    injectFileFormat(filename: string, defaultFilename: string): string {
        return `${filename || defaultFilename}.mp3`;
    },
};
